<template>
  <div class="index-context" v-loading="isLoading">
    <!-- <div class="bg-img" :style="{'background-image': `url(${require('@/assets/img/cmdinfo-bg.jpg')})`}"> -->
    <div v-if="deviceType == 'mobile'" class="mobile-app">
      <div class="app-header-bg">
        <!-- <img src="~@/assets/img/app/banner.png" > -->
      </div>
      <div class="mobile-content">
        <div class="card" v-for="item in configList" :key="item.id"  @click.stop="choiceTag(item.text, item.type, true)">
          <div class="img"><img :src="item.imgSrc"></div>
          <div class="content">
            <div class="left">{{item.text}}</div>
            <div class="right"><i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="header-bg" id="headerBg">
        
      </div>
      <div id="background">
        <div v-show="showMain">
          <img src="~@/assets/img/logo.png" id="centerImg" class="center-img">
          <img src="~@/assets/img/1.png" id="img01" class="circle img01">
          <img src="~@/assets/img/2.png" id="img02" class="circle img02">
          <img src="~@/assets/img/2.png" id="img03" class="circle img03">
          <div ref="swcs" id="img1" class="circle img1">
              <img src="~@/assets/img/小智解读.png">
              <div class="min-circle" @click.stop="choiceTag('小智解读', 'xiaozhijiedu', true)"></div>
          </div>
          <div ref="fzzw" id="img2" class="circle img2">
              <img src="~@/assets/img/小智学习.png">
              <div class="min-circle" @click.stop="choiceTag('小智学习', 'xiaozhixuexi', true)"></div>
          </div>
          <div ref="xzxw" id="img3" class="circle img3">
              <img src="~@/assets/img/小智写文.png">
              <div class="min-circle" @click.stop="choiceTag('小智写文', 'xiaozhixiewen', true)"></div>
          </div>
          <div ref="fxbg" id="img4" class="circle img4">
              <img src="~@/assets/img/小智分析.png">
              <div class="min-circle" @click.stop="choiceTag('小智分析', 'xiaozhifenxi', true)"></div>
          </div>
          <div ref="xzts" id="img5" class="circle img5">
              <img src="~@/assets/img/小智透视.png">
              <div class="min-circle" @click.stop="choiceTag('小智透视', 'xiaozhitoushi', true)"></div>
          </div>
        </div>
      </div>

      <site-footer></site-footer>
    </div>
    <login :is-login-visible="isLoginVisible" @login-success="loginSuccess" @closeDialog="isLoginVisible = false"></login>

    <changeEid ref="mychangeEid" isopenUrl></changeEid>
    <el-dialog :visible.sync="showNoTagTip" :close-on-click-modal="false" :close-on-press-escape="false"
               :show-close="false" width="450px" top="15vh">
      <div style="text-align: center;">
        <img src="~@/assets/img/contact_me_qr.png" style="height: 400px; width: 400px;" alt="">

        <div style="margin: 10px;font-size: 12px;">
          请使用微信扫码联系客服，即可获取产品使用权限。
          <br>
          点击
          <el-button type="text" size="mini" @click="refreshMacthTagViast">刷新</el-button>
          更新您的状态
        </div>

      </div>
    </el-dialog>
    <el-dialog v-if="showReaderDialog"
               :title="dialogTitle"
               :visible.sync="showReaderDialog"
               :fullscreen="isFullScreen"
               width="80%"
               :close-on-click-modal='false'
               :before-close="handleClose"
               append-to-body
               z-index="100"
               class="index-dialog"
    >
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            {{ dialogTitle }}
          </span>
          <i v-if="!isFullScreen" class="el-icon-full-screen icon-full" @click="isFullScreen = !isFullScreen"></i>
          <i v-if="isFullScreen" class="el-icon-copy-document icon-full" @click="isFullScreen = !isFullScreen"></i>
        </div>
      </template>
      <div :class="{'not-full-screen-body': !isFullScreen, 'full-screen-body': isFullScreen}">
        <!-- 小智解读 -->
        <cmdp-workshop-intensive v-if="readerType == 'xiaozhijiedu'" orgFullName="中广核核技术发展股份有限公司" orgSecCode="003816"
                                 :domain="serverUrl" :satoken="requestHeader.satoken"></cmdp-workshop-intensive>
        <!-- 辅助撰文弹窗 -->
        <cmdp-reader-search v-else-if="readerType == 'fuzhuzhuanwen'" orgFullName="中广核核技术发展股份有限公司" orgSecCode="003816"
                            :domain="serverUrl" :satoken="requestHeader.satoken"></cmdp-reader-search>
        <!-- 仿写报告弹窗 -->
        <cmdp-workshop-ult v-if="readerType == 'fangXieBaoGao'" :domain="serverUrl"
                           :satoken="requestHeader.satoken"></cmdp-workshop-ult>
        <!-- 小智写文 -->
        <cmdp-writer v-if="readerType == 'xiaozhixiewen'" :domain="serverUrl"
                     :satoken="requestHeader.satoken"></cmdp-writer>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiAxios from "@/config/apiAxios";
import userApi from "@/assets/js/userApi";
import siteFooter from "@/components/common/siteFooter";
import PdfPreview from "./pdfPreview"
import login from "../../user/login";
import changeEid from "./components/changeEid.vue";
export default {
  name: "indexContext",
  components: {
    siteFooter,
    // userpbctool,
    // writterpbctool,
    login,
    PdfPreview,
    changeEid
  },
  data() {
    return {
      isLoading: false,
      useToolVisible: false,
      toolType: 'user',
      dialogTitle: "",
      dialogText: "",
      screenWidth: null,
      isFullScreen: false,
      // indexImgSrc: require("@/assets/img/cmdinfo-index.png")
      indexImgSrc: require("@/assets/img/cmdinfo-index2.png"),
      secondBgImgSrc: require("@/assets/img/cmdinfo-bg2.jpg"),
      toolBoxList: [],
      dataObj: {},
      isLoginVisible: false,
      dialogWidth: "600px",
      showRst: false,
      rstFileInfo: {},
      pdfPreviewUrl: "",
      requestHeader: {
        satoken: localStorage.getItem('USER_TOKEN_VAL')
      },
      infoObject: {},
      readerLabel: "",
      showReaderDialog: false,
      fangXieBaoGao: false,
      3: false,
      serverUrl: config.serverUrl,
      readerType: "",  //需要打开的阅读器类型
      // isgetTableData:false, // 是否获取远程数据
      showNoTagTip: false, // 没有匹配标签的提示dialog
      matchTag: 'prod_数据开放平台_用户状态_通过',
      // matchTag: '客户类型_上市公司',
      isValidTag: window.config.active == "prod", // 是否开启标签验证， 生产开启，测试关闭
      viewSmartstudy    : false, //prod_smartstudy_reject
      viewSmartinsight  : false, //prod_smartinsight_reject
      viewSmartanalyze  : false, //prod_smartanalyze_reject
      cmdinfoEl:{},
      deviceType: window.deviceType || 'pc',
      showMain: false,
      configList:[
        {
          id: "1",
          text: "小智解读",
          imgSrc: require("@/assets/img/app/小智解读.png"),
          type: "xiaozhijiedu"
        },
        {
          id: "2",
          text: "小智学习",
          imgSrc: require("@/assets/img/app/小智学习.png"),
          type: "xiaozhixuexi"
        },
        {
          id: "3",
          text: "小智写文",
          imgSrc: require("@/assets/img/app/小智写文.png"),
          type: "xiaozhixiewen"
        },
        {
          id: "4",
          text: "小智分析",
          imgSrc: require("@/assets/img/app/小智分析.png"),
          type: "xiaozhifenxi"
        },
        {
          id: "5",
          text: "小智透视",
          imgSrc: require("@/assets/img/app/小智透视.png"),
          type: "xiaozhitoushi"
        },
      ]
    }
  },
  methods: {

    loginSuccess(){


      this.refreshMacthTagViast();
      this.isLoginVisible=false;
    },
    /**
     * 页面打开
     * value
     * readerType
     * _blank boolen true-新打开页面，false-弹窗dialog打开
     */
    choiceTag(value, readerType, _blank = false) {
      this.readerType = readerType;
      let _isLogin = localStorage.getItem("USER_ISLOGIN") == 'true';
      if (!_isLogin) {
        this.isLoginVisible = true;
        return;
      }

      this.requestHeader.satoken = localStorage.getItem('USER_TOKEN_VAL'); //登录后没有刷新页面，需要重新取token
      sessionStorage.setItem( 'USER_ISLOGIN', true );
      // let dataObj = null;
      // this.toolBoxList.forEach(item => {
      //   if (item.name == value) {
      //     dataObj = item;
      //   }
      // });
      let newpage = false;
      if (readerType == 'xiaozhijiedu') {
        newpage = this.$router.resolve({
          name: 'smartGenie'
        })
      } else if (readerType == 'xiaozhixiewen' && this.viewSmartinsight) {
        newpage = this.$router.resolve({
          name: 'smartInsight'
        })
      } else if (readerType == 'xiaozhixuexi' && this.viewSmartstudy ) {
        newpage = this.$router.resolve({
          name: 'smartStudy'
        })
      }else if( readerType == 'xiaozhifenxi' && this.viewSmartanalyze ){
        this.$refs.mychangeEid.showDialog();
        return;
        // newpage = this.$router.resolve({
        //   name: 'smartAnalyze'
        // })
        // newpage = {
        //   href : `${config.cmdpUrl}/plus/apps/bigScreen/decsisionSupportVega`
        // }
      }else if( readerType == 'xiaozhitoushi' ){
        newpage = this.$router.resolve({
          name: 'smartPerspective'
        })
      }

      newpage && window.open(newpage.href, '_blank');
      return;


      if (['仿写报告', '小智解读', '辅助撰文', '公告精读', '小智写文'].includes(value)) {
        if (_blank) {
          // 新窗口打开
          let newpage = this.$router.resolve({
            name: 'readerPage',
            query: {readerType: readerType},
          })
          window.open(newpage.href, '_blank');
        } else {
          // 弹窗dialog打开
          if (value == "仿写报告") {
            this.dialogTitle = "仿写报告";
            this.showReaderDialog = true;
          } else if (value == "小智解读") {
            this.dialogTitle = "小智解读";
            this.showReaderDialog = true;
          } else if (value == "辅助撰文") {
            this.dialogTitle = "辅助撰文";
            this.showReaderDialog = true;
          } else if (value == "公告精读") {
            this.dialogTitle = "公告精读";
            this.showReaderDialog = true;
          } else if (value == "小智写文") {
            this.dialogTitle = "小智写文";
            this.showReaderDialog = true;
          }

        }
      } else {
        if (dataObj) {
          this.dataObj = dataObj;
          this.dialogTitle = dataObj.name;
          this.toolType = 'user';
          this.useToolVisible = true;
          let that = this;
          that.$nextTick(() => {
            // that.$refs.myvuserpbctool.initPbc(dataObj);
          })
        } else {
          this.dialogTitle = value;
          this.dialogText = "建设中......";
          this.toolType = 'user';
          this.useToolVisible = true;
        }
      }

    },
    //查询工具箱列表
    getTableDatas() {
      this.isLoading = true;
      let params = {
        //   "userId": this.userInfo._id,  //可以不用传，接口会自动增加uid参数
        "tags": ["tech_sbom"],
        "filter": "'fileInfo.extends.resource.delStatus' eq 1  and 'fileInfo.extends.resource.type' eq '1'"
      }
      //查询表格数据
      apiAxios.apmSyncPost('virtual_tool_box_list_00001', params, {}, _res => { //虚拟用户，执行和获取ui配置有问题
        //  apiAxios.apmSyncPost('tool_box_list_00001', params, {}, _res => {
        if (_res.code == 200) {
          let data = _res.data.data || [];
          //    this.isgetTableData=true;
          if (data.length <= 0) {
            this.isLoading = false;
            return;
          }
          this.toolBoxList = data;
          this.isLoading = false;
        } else {
          if( _res?.data?.code == 500 && _res?.data?.msg == 'token无效' ){
            this.isLoading = false;
            this.isLoginVisible = true;
          }else{
            this.$message.error(_res.msg);
            this.isLoading = false;
          }
        }
      });
    },
    handleClose() {
      this.dialogText = ''
      this.rstFileInfo = {};
      this.infoObject = {};
      this.pdfPreviewUrl = "";
      this.showRst = false;
      this.useToolVisible = false;
      this.isFullScreen = false;
      this.dialogWidth = "600px";
      this.showReaderDialog = false;
    },
    backBtn() {
      this.dialogWidth = "600px";
      this.rstFileInfo = {};
      this.infoObject = {};
      this.showRst = false;
    },
    onSuccess(docObj) {
      this.rstFileInfo = docObj.fileInfo;
      if (docObj?.data?.contentType == "IdentityRead") {
        let outputParams = [];
        let output = this.rstFileInfo?.extends?.output || {};
        let outputKeys = Object.keys(output).forEach(item => {
          let obj = {};
          if (item.indexOf("cat_std") != -1) {
            obj.paramsKey = "cat_sys";
            obj.path = output[item].path;
            outputParams.push(obj);
          } else if (item.indexOf("cat_chapter") != -1) {
            obj.paramsKey = "cat_sys_chapter";
            obj.path = output[item].path;
            outputParams.push(obj);
          } else if (item.indexOf("ctx_") != -1 && item.indexOf("ctx_anno") == -1) {
            obj.paramsKey = "ctx_sys_json";
            obj.path = output[item].path;
            outputParams.push(obj);
          } else if (item.indexOf("cat_html") != -1) {
            obj.paramsKey = "cat_sys_html";
            obj.path = output[item].path;
            outputParams.push(obj);
          } else if (item.indexOf("audit_") != -1) {
            obj.paramsKey = "audit_09_json";
            obj.path = output[item].path;
            outputParams.push(obj);
          }
        })
        let infoObjectTem = {
          "base": this.rstFileInfo
        }
        //获取output对象里对应的文件的fileInfo信息
        apiAxios.apmSyncPost('get_output_info_list_00001', {outputParams}, {}, _res => {
          if (_res.code == 200) {
            let data = _res.data.data || [];
            data.forEach(item => {
              if (item.outputKeys?.response?.code == 200) {
                infoObjectTem[item.outputKeys.paramsKey] = item.outputKeys.response.data;
              }
            })
            this.infoObject = infoObjectTem;
          } else {
            this.$message.error(_res.msg);
          }
        });

        this.showIdentityRead = true;
      } else {
        this.showIdentityRead = false;
        this.pdfPreviewUrl = this.rstFileInfo.extends.resource.fileContentUrl;
      }
      this.showRst = true;
      this.dialogWidth = "80%";
    },

    // 刷新获取匹配的标签
    refreshMacthTagViast(responce) {
      let token=sessionStorage.getItem("token");
      console.log('refreshMacthTagViast')
     // userApi.getCurUsrTags(_r => {
      userApi.getCurUsrInfo(token).then(_r=>{
        let userInfo=JSON.parse(sessionStorage.getItem("USER_INFO"));
        let tags=userInfo.tags ||[];
        this.viewSmartstudy   = tags.indexOf("prod_smartstudy_reject")>-1 ? false : true;
        this.viewSmartinsight = tags.indexOf("prod_smartinsight_reject")>-1 ? false : true;
        this.viewSmartanalyze = tags.indexOf("prod_smartanalyze_reject") >-1? false : true;

        if (tags.indexOf(this.matchTag)>-1) {
          this.showNoTagTip = false
          sessionStorage.setItem("USER_ISMATCHTAG", true)
          if (responce) responce()
        } else {
          this.showNoTagTip = true
          sessionStorage.setItem("USER_ISMATCHTAG", false)
        }
      })
    },

    resizeCircles() {
      this.showMain = true;
      let w = this.cmdinfoEl.background.offsetWidth;
      let h = this.cmdinfoEl.background.offsetHeight;
      let centerW = w/2;
      let centerH = h/2;
      
      let initw = 200;

      let shrink = 1;
      let shrinkW = 1;
      let shrinkH = 1;
      if(w < 1020){
        shrink = 1.5;
        shrinkW = 1.3;
      }
      if(h < 605){
        shrinkH = 1.2;
      }

      this.cmdinfoEl.img01.style.left = `${centerW - 200/shrinkW}px`;
      this.cmdinfoEl.img01.style.top = `${centerH - 250/shrinkH}px`;
      this.cmdinfoEl.img01.style.width = `${(initw / 1.3)/shrink}px`;

      this.cmdinfoEl.img02.style.left = `${centerW + 80/shrinkW}px`;
      this.cmdinfoEl.img02.style.top = `${centerH - 50/shrinkH}px`;
      this.cmdinfoEl.img02.style.width = `${(initw / 2)/shrink}px`;

      this.cmdinfoEl.img03.style.left = `${centerW - 400/shrinkW}px`;
      this.cmdinfoEl.img03.style.top = `${centerH + 100/shrinkH}px`;
      this.cmdinfoEl.img03.style.width = `${(initw / 2)/shrink}px`;

      this.cmdinfoEl.img1.style.left = `${centerW - 500/shrinkW}px`;
      this.cmdinfoEl.img1.style.top = `${centerH - 250/shrinkH}px`;
      this.cmdinfoEl.img1.style.width = `${(initw * 2)/shrink}px`;

      this.cmdinfoEl.img2.style.left = `${centerW - 50/shrinkW}px`;
      this.cmdinfoEl.img2.style.top = `${centerH - 330/shrinkH}px`;
      this.cmdinfoEl.img2.style.width = `${(initw * 1.3)/shrink}px`;

      this.cmdinfoEl.img3.style.left = `${centerW + 130/shrinkW}px`;
      this.cmdinfoEl.img3.style.top = `${centerH - 250/shrinkH}px`;
      this.cmdinfoEl.img3.style.width = `${(initw * 2)/shrink}px`;

      this.cmdinfoEl.img4.style.left = `${centerW + 20}px`;
      this.cmdinfoEl.img4.style.top = `${centerH + 40}px`;
      this.cmdinfoEl.img4.style.width = `${(initw * 1.5)/shrink}px`;

      this.cmdinfoEl.img5.style.left = `${centerW - 250/shrinkW}px`;
      this.cmdinfoEl.img5.style.top = `${centerH + 50/shrinkH}px`;
      this.cmdinfoEl.img5.style.width = `${(initw * 1.3)/shrink}px`;
    }
  },
  created() {
    userApi.getCurUsrInfo().then(_r=>{
  //  userApi.getCurUsrInfo(_r=>{
    let _isLoginSes = localStorage.getItem("USER_ISLOGIN") == 'true';
    if (_isLoginSes) {

      if (this.isValidTag ) {
        this.refreshMacthTagViast( this.getTableDatas )
      } else {
        this.viewSmartstudy   = true;
        this.viewSmartinsight = true;
        this.viewSmartanalyze = true;
        this.showNoTagTip     = false
        sessionStorage.setItem("USER_ISMATCHTAG", true)
        // this.getTableDatas();
      }
   

    }
  })

  },
  mounted() {
    // window.onresize = () => {
    //   return (() => {
    //     this.screenWidth = document.body.clientWidth;
    //   })()
    // }
    if(this.deviceType == "pc"){
      // 页面加载完成后初始化圆圈大小
      window.addEventListener("load", () => {
              this.cmdinfoEl = {};
              let background = document.getElementById("background");
              let img01 = document.getElementById("img01");
              let img02 = document.getElementById("img02");
              let img03 = document.getElementById("img03");
              let img1 = document.getElementById("img1");
              let img2 = document.getElementById("img2");
              let img3 = document.getElementById("img3");
              let img4 = document.getElementById("img4");
              let img5 = document.getElementById("img5");
              this.cmdinfoEl.background = background;
              this.cmdinfoEl.img01 = img01;
              this.cmdinfoEl.img02 = img02;
              this.cmdinfoEl.img03 = img03;
              this.cmdinfoEl.img1 = img1;
              this.cmdinfoEl.img2 = img2;
              this.cmdinfoEl.img3 = img3;
              this.cmdinfoEl.img4 = img4;
              this.cmdinfoEl.img5 = img5;
              
              this.resizeCircles();
          });
      // 监听窗口大小改变事件
      window.addEventListener("resize", this.resizeCircles);
    }
  },
  beforeMount() {
    this.$nextTick(_ => {
      this.screenWidth = document.body.clientWidth - 18;
    })
  },
}
</script>

<style lang="less" scoped>

@bg-yellow-color: #ffefdb;
@bg-green-color: #c3eae2;
@bg-blue-color: #c7e8ed;
@bg-red-color: #f7d4d5;
@white-color: #fff;

:root {
  --width: 218;
  --height: 218;
  --top: 195;
  --left: 512;
}

.brief{
  color: #656469;
    width: 360px;
    margin: 20px 0 0 0;
}

.index-context {
  // min-width: 1000px;
  // min-height: 700px;
  height: 100vh;
  width: 100vw;
  overflow: auto;

  .header-bg {
    width: 100%;
     height: calc(100vh - 40px - 80vh);
   // height: 300px;
    min-height: 110px;
    min-width: 800px;
     background-image: url('../../../assets/img/cmdinfo-bg1.jpg');
   // background-image: url('../../../assets/img/banner.png');
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 1000px) {
    .header-bg {
        background-image: url('../../../assets/img/banner_01.png');
    }
  }
  #background {
    position: relative;
    width: 100%;
    height: calc(100vh - 20vh);
    min-height: 500px;
    min-width: 800px;
    background-image: url('../../../assets/img/cmdinfo-center-bg.jpg');
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }

  .center-img {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .circle {
    position: absolute;
    width: 200px;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .min-circle {
    position: absolute;
    height: 50%;
    width: 50%;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
}


.index-img {
  width: 100%;
  height: 100%;
}

.full-body-height {
  height: calc(100vh - 80px);
}

.nofull-body-height {
  // min-height: 100px;
  // height: calc(100vh - 260px);
  //min-height: calc(100vh - 260px);
}

.nofull-tool-result {
  height: calc(100% - 260px);
}

.tool-form {
  // width: 500px;

  // background:#bg-color[deep3];
  /deep/ .is-horizontal {
    display: none;
  }
}

.tool-result {
  width: 100%;
  margin-bottom: 10px;
  // height: calc(100vh - 260px);

  .read-view {
    height: 100%;
    text-align: initial;
  }

  .form-button {
    margin-top: 5px;
  }
}

.form-button {
  text-align: center;
}

.avue-crud__dialog__header {
  text-align: left;

  .el-dialog__title {
    float: left;
    overflow: hidden;
    width: 80%;
    text-overflow: ellipsis;
    word-break: keep-all;

  }

  .icon-full {
    float: right;
    margin-right: 30px;
    margin-top: 4px;
    cursor: pointer;
  }
}

.dialog_login_body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.pri-text1 {
  color: #568cd5;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
}

.pri-text .impt {
  text-align: center;
}

.isbuding {
  padding-top: 30px;
  height: 100px;

  text-align: center;

}

.index-dialog {
  /deep/ .el-dialog__header {
    margin-bottom: 10px;
  }

  .not-full-screen-body {
    height: calc(100vh - 15vh - 110px);
  }

  .full-screen-body {
    height: calc(100vh - 60px);
  }
}

.app-tool {
  overflow-x: auto;

  /deep/ .vertical-layout-item, /deep/ .row {
    padding: 0px;
    margin: 0px;
  }

  /deep/ .v-card__title, /deep/ .v-card__text {
    padding: 8px;
  }

  /deep/ .v-input, /deep/ .v-label, /deep/ .v-card__title {
    font-size: 14px !important;
    padding-top: 0px;
  }
}



//手机端
.mobile-app{
  .app-header-bg {
    height: 200px;
    background-image: url('../../../assets/img/app/banner.png');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .mobile-content {
    margin-bottom: 20px;
    .card {
      display: flex;
      padding: 20px;
      align-items: center;
      font-size: 24px;

      .img {
        margin-right: 20px;
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
      .content {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;

        .right i{
          color: #ccc;
        }
      }
    }
  }

}

</style>
